
import Navbar from "../../components/Navbar";
import SectionDivider from "../../components/SectionDivider";
import WebLoading from "../../components/WebLoading";
import { InfoData, SectionData } from "../../hooks/useApiCalls";
import Faq from "./Faq/Faq";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import HowToBuy from "./HowToBuy/HowToBuy";
import Roadmap from "./Roadmap/Roadmap";
import Team from "./Team/Team";
import Tokenomics from "./Tokenomics/Tokenomics";



function Home() {

    const titleData = InfoData();
    document.title = titleData.title ? titleData.title : "Loading...";
    const sections = SectionData();

     return ( 
        <>

        <WebLoading/>
        <Navbar/>
        {sections.custom == 1 ? <> <Header/> <SectionDivider/></>   : "" }
       
        {sections.howtobuy == 1 ? <><HowToBuy/><SectionDivider/></>  : "" }
        
        {sections.roadmap == 1 ? <><Roadmap/><SectionDivider/></>  : "" }
        
        {sections.tokenomics == 1 ? <><Tokenomics/> <SectionDivider/></> : "" }  
        
        {sections.team == 1 ? <><Team/>  <SectionDivider/></>  : "" } 
       
        {sections.faq == 1 ? <><Faq/> <SectionDivider/></> : "" }  
        
        <Footer/>
      </> 
  ); 
}

export default Home;